import { AnchorHTMLAttributes, forwardRef } from "react";
import { Link } from "react-router";

const LinkButton = forwardRef<
    HTMLAnchorElement,
    AnchorHTMLAttributes<HTMLAnchorElement>
>(({ href, ...props }, ref) => <Link to={href ?? "/"} {...props} ref={ref} />);

LinkButton.displayName = "LinkButton";

export default LinkButton;
